import { render } from "./SubSecondManage.vue?vue&type=template&id=27c0b8d2"
import script from "./SubSecondManage.vue?vue&type=script&setup=true&lang=js"
export * from "./SubSecondManage.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/SubSecondStreaming/SubSecondManage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "27c0b8d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('27c0b8d2', __exports__)) {
    api.reload('27c0b8d2', __exports__)
  }
  
  module.hot.accept("./SubSecondManage.vue?vue&type=template&id=27c0b8d2", () => {
    api.rerender('27c0b8d2', render)
  })

}


export default __exports__